export default "__VITE_ASSET__d32e9937__"